<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Instruksi</strong> Pemeriksaan </h1>
            <div>
              Berikan penilaian pada kandidat berikut ini.
            </div>
            <v-row dense no-gutters class="my-3">
              <v-col cols="12" md="5">
                <v-card flat outlined>
                  <v-card-text class="py-0">
                    <v-list>
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <div class="black--text subtitle-2">
                            {{ $getDeepObj(initValue, 'ptk.nama') || '-' }}
                          </div>
                          <div class="caption">
                            <div style="line-height: 1rem">
                              <v-icon small class="mb-1 mr-2">mdi-label-outline</v-icon>
                              {{ $getDeepObj(initValue, 'ptk.email') || '-' }}
                            </div>
                            <div>
                              <v-icon small class="mb-1 mr-2">mdi-office-building</v-icon>
                              {{ $getDeepObj(initValue, 'sekolah.nama') || '-' }}
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto container">
      <v-card-text>
        <h2 class="black--text">Rubrik Penilaian</h2>
        <v-spacer class="my-2" />
        <component ref="form" :is="component" :init-value="initValue" :rubriks="rubriks" :mode="mode" />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import FormKeterampilan from './nilai/Keterampilan';
import FormKehadiran from './nilai/Kehadiran';

export default {
  components: { FormKeterampilan, FormKehadiran },
  props: {
    initValue: {
      type: Object,
      default: () => {},
    },
    rubriks: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'form',
    },
    kelompok: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    component() {
      return this.kelompok === 'keterampilan' ? 'FormKeterampilan' : 'FormKehadiran';
    },
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },

    getValue() {
      return this.$refs.form.getValue();
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
